import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

// 고정(fixed/pinned) 요소의 top 기준값
const fixedTop = 43; // main-gnb 아래
const fixedTopWithSubGnb = 123; // main-gnb + sub-gnb 아래

// sale 카테고리 탭이 내려앉는 자리. 페이지가 잰 GNB 바 높이를 --sale-pin-top으로 받는다
// (앱 웹뷰처럼 GNB가 없으면 0이 들어온다)
const salePinTop = `var(--sale-pin-top, ${fixedTop}px)`;

// 카테고리 탭(CategoryMenuBar type5) 높이. LP 필터바 .pin-area이 이 아래에 붙는다
// (smMax에서는 49px 기준 vw)
const categoryMenuBarHeight = 50;

// exclusive 탭 라벨 높이. 고정 시 필터바/정렬바가 이 아래에 붙는다
const exclusiveTabsLabelHeight = 44;

// 페이지 하단 여백
const pagePaddingBottom = 145;

export const MainLayout = styled.div`
  #container {
    min-height: calc(100vh - 100px);
  }

  .box-main-header {
    position: relative;
    height: 93px;
    z-index: 99;

    .inner-box-main-header {
      width: 100%;
      position: relative;

      #main-gnb-bar {
        border-bottom: 1px solid #eee;
      }

      .sub-gnb-list .swiper {
        padding: 8px 20px 14px;

        .swiper-slide + .swiper-slide {
          margin-left: 6px;
        }
      }
    }
  }

  &:not(.is-fix-header) .box-main-header:has(.sub-gnb-list) {
    height: 179px;
  }

  body.airbridge-banner-opened & {
    #container {
      position: relative;
      z-index: 10;
      background-color: #fff;
    }
  }

  &.is-fix-header {
    .inner-box-main-header {
      position: fixed;
      transition: transform 0.3s;
      top: -50px;
      transform: translateY(0);
    }

    &.is-scrollUp .inner-box-main-header {
      transform: translateY(50px);
    }

    &.is-scrollDown {
      .inner-box-main-header {
        #header {
          z-index: 0;
        }
      }

      .sub-gnb-list {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: -1;
      }
    }
  }

  &.main-page {
    #header .header-main .btn-cart .count {
      color: #fff;
      background-color: #000;
    }

    #container > .content {
      margin-top: -93px;
    }

    .box-main-header {
      .inner-box-main-header {
        background: rgba(0, 0, 0, 0.7);

        #main-gnb-bar {
          border-bottom: 0;
        }
      }
    }

    &.is-fix-header {
      .box-main-header {
        .inner-box-main-header {
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }

  &.best-page {
    padding-bottom: ${pagePaddingBottom}px;

    .area-menu {
      position: relative;
      z-index: 10;
      height: 50px;

      &.is-3deps {
        height: 91px;
      }

      .inner-area-menu {
        width: 100%;
        position: relative;
      }
    }

    &.is-fix-header {
      .inner-area-menu {
        position: fixed;
        transition: transform 0.3s;
        top: ${fixedTop}px;
        transform: translateY(0);
      }

      &.is-scrollUp {
        .inner-area-menu {
          transform: translateY(50px);
        }
      }

      &.is-scrollDown {
        .cm-type4 {
          opacity: 0;
          visibility: hidden;
          position: absolute;
          top: 0;
          z-index: 0;
        }
      }
    }
  }

  &.main-category-page {
    padding-bottom: ${pagePaddingBottom}px;

    .box-main-header {
      .inner-box-main-header {
        #main-gnb-bar {
          border-bottom: 0;
        }
      }
    }
  }

  &.for-you-page {
    padding-bottom: ${pagePaddingBottom}px;

    .for-you-main-template {
      .area-menu {
        position: relative;
        height: 53px;
        z-index: 10;

        .inner-area-menu {
          width: 100%;
          position: relative;
        }

        &.is-pinned .inner-area-menu {
          position: fixed;
          transition: transform 0.3s;
          top: ${fixedTop}px;
          transform: translateY(0);
        }
      }
    }

    &.is-scrollUp {
      .for-you-main-template {
        .is-pinned .inner-area-menu {
          transform: translateY(50px);
        }
      }
    }
  }

  &.new-page {
    padding-bottom: ${pagePaddingBottom}px;

    .lp-filter-bar.is-pinned .pin-area {
      z-index: 10;
      position: fixed;
      transition: transform 0.3s;
      top: ${fixedTop}px;
      transform: translateY(0);
    }

    &.is-scrollUp {
      .lp-filter-bar.is-pinned .pin-area {
        transform: translateY(50px);
      }
    }
  }

  &.sale-page {
    padding-bottom: ${pagePaddingBottom}px;

    .area-menu {
      position: relative;
      z-index: 10;

      .inner-area-menu {
        width: 100%;
        position: relative;
      }

      /* 구필터바(.filter-listbar) 구조 : 블록을 통째로 고정한다 */
      &.is-pinned .inner-area-menu:not(:has(.lp-filter-bar)) {
        position: fixed;
        transition: transform 0.3s;
        top: ${fixedTop}px;
        transform: translateY(0);
      }

      /* LP 필터바 구조 : 1행(퀵 필터)은 고정 제외 대상이라 카테고리 탭과 필터바 .pin-area를
         각자 제 위치에 닿는 시점에 따로 고정한다(is-pinned / is-pinned-filter) */
      &.is-pinned .inner-area-menu:has(.lp-filter-bar) {
        /* 고정되어 빠져나간 카테고리 탭(type5) 자리만큼 보정해 1행이 튀지 않게 한다 */
        padding-top: ${categoryMenuBarHeight}px;
      }

      &.is-pinned:has(.lp-filter-bar) .category-menubar,
      &.is-pinned-filter .lp-filter-bar .pin-area {
        position: fixed;
        left: 0;
        right: 0;
        transition: transform 0.3s;
        transform: translateY(0);
        background-color: #fff;
      }

      &.is-pinned:has(.lp-filter-bar) .category-menubar {
        top: ${salePinTop};
      }

      /* 고정된 카테고리 탭 바로 아래 */
      &.is-pinned-filter .lp-filter-bar .pin-area {
        top: calc(${salePinTop} + ${categoryMenuBarHeight}px);
      }

      @media ${({ theme }) => theme.media.smMax} {
        &.is-pinned .inner-area-menu:has(.lp-filter-bar) {
          padding-top: ${mixin.pxToVw('49')};
        }

        &.is-pinned-filter .lp-filter-bar .pin-area {
          top: calc(${salePinTop} + ${mixin.pxToVw('49')});
        }
      }
    }

    &.is-scrollUp {
      .is-pinned .inner-area-menu:not(:has(.lp-filter-bar)),
      .is-pinned:has(.lp-filter-bar) .category-menubar,
      .is-pinned-filter .lp-filter-bar .pin-area {
        transform: translateY(50px);
      }
    }
  }

  &.exclusive-page {
    padding-bottom: ${pagePaddingBottom}px;

    /* LP 필터바의 .pin-area은 1행(퀵 필터)이 지나간 뒤에 고정되므로 별도 상태를 쓴다 */
    .tabs.is-pinned .tabs-label,
    .tabs.is-pinned .filter-listbar .inner,
    .tabs.is-pinned-filter .lp-filter-bar .pin-area,
    .tabs.is-pinned .sorting-accrdn .inner-sorting {
      top: 5px;
      transform: translateY(0);
    }

    /* LP 필터바 .pin-area은 고정 시점이 한 박자 늦으므로 전환도 자기 상태를 따른다.
       is-motion을 같이 쓰면 고정되는 순간의 자리잡기까지 애니메이션된다 */
    .tabs.is-motion .tabs-label,
    .tabs.is-motion .filter-listbar .inner,
    .tabs.is-motion-filter .lp-filter-bar .pin-area,
    .tabs.is-motion .sorting-accrdn .inner-sorting {
      transition: transform 0.3s;
    }

    &.is-scrollUp {
      .tabs.is-pinned .tabs-label {
        transform: translateY(86px);
      }

      .tabs.is-pinned .filter-listbar .inner,
      .tabs.is-pinned-filter .lp-filter-bar .pin-area,
      .tabs.is-pinned .sorting-accrdn .inner-sorting {
        transform: translateY(130px);
      }
    }

    &.is-scrollDown {
      .tabs.is-pinned .tabs-label {
        transform: translateY(38px);
      }

      .tabs.is-pinned .filter-listbar .inner,
      .tabs.is-pinned-filter .lp-filter-bar .pin-area,
      .tabs.is-pinned .sorting-accrdn .inner-sorting {
        transform: translateY(82px);
      }
    }
  }

  &.event-mainLayout {
    .box-main-header {
      .inner-box-main-header {
        #main-gnb-bar {
          border-bottom: 0;
        }
      }
    }

    .corner-lp-wrap .corner-lp-navi {
      z-index: 89;
    }

    .corner-navi.fixed .event-navigation,
    .corner-navi2.fixed .event-navigation-type2,
    .corner-lp-wrap.fixed .corner-lp-navi .event-navigation {
      transition: transform 0.3s;
      top: ${fixedTop}px;
    }

    &.is-fix-header {
      &.is-scrollUp {
        .corner-navi.fixed .event-navigation,
        .corner-navi2.fixed .event-navigation-type2,
        .corner-lp-wrap.fixed .corner-lp-navi .event-navigation {
          transform: translateY(50px);
        }

        &:has(.sub-gnb-list) {
          .corner-navi.fixed .event-navigation,
          .corner-navi2.fixed .event-navigation-type2,
          .corner-lp-wrap.fixed .corner-lp-navi .event-navigation {
            top: ${fixedTopWithSubGnb}px;
          }
        }
      }

      &.is-scrollDown {
        .corner-navi.fixed .event-navigation,
        .corner-navi2.fixed .event-navigation-type2,
        .corner-lp-wrap.fixed .corner-lp-navi .event-navigation {
          transform: translateY(0px);
        }
      }
    }

    .view-product-btn {
      position: fixed;
      bottom: calc(constant(safe-area-inset-bottom) + 60px);
      bottom: calc(env(safe-area-inset-bottom) + 60px);
      left: 0;
      right: 0;
      z-index: 99;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease 0s, visibility 0.3s ease 0s;
      margin: 0 auto;

      &.active {
        opacity: 1;
        visibility: visible;
      }
    }

    &:has(#footer) {
      .event-lp {
        padding-bottom: 0;
      }

      .contents-wrap:not(.lp-event) section:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  &.mega-promotion-page {
    padding-bottom: ${pagePaddingBottom}px;

    .box-main-header {
      .inner-box-main-header {
        #main-gnb-bar {
          border-bottom: 0;
        }
      }
    }

    .corner-lp-wrap.fixed {
      padding-top: 0;

      .filter-listbar {
        height: 64px;
      }

      .evt-ctg-navigation-wrap {
        height: 56px;
      }
    }

    .corner-navi.fixed .event-navigation,
    .corner-navi.fixed .event-navigation-type2,
    .corner-collection-section.fixed .category-tab .menubar-swiper,
    .corner-lp-wrap.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation,
    .corner-lp-wrap.fixed .filter-listbar .inner {
      transition: transform 0.3s;
      top: ${fixedTop}px;
    }

    &.is-scrollUp:has(.sub-gnb-list) {
      .corner-navi.fixed .event-navigation,
      .corner-navi.fixed .event-navigation-type2,
      .corner-collection-section.fixed .category-tab .menubar-swiper,
      .corner-lp-wrap.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation {
        top: ${fixedTopWithSubGnb}px;
      }
    }

    &.is-fix-header {
      &.is-scrollUp {
        .corner-navi.fixed .event-navigation,
        .corner-navi.fixed .event-navigation-type2,
        .corner-collection-section.fixed .category-tab .menubar-swiper,
        .corner-lp-wrap.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation,
        .corner-lp-wrap.fixed .filter-listbar .inner {
          transform: translateY(50px);
        }
      }

      &.is-scrollDown {
        .corner-navi.fixed .event-navigation,
        .corner-navi.fixed .event-navigation-type2,
        .corner-collection-section.fixed .category-tab .menubar-swiper,
        .corner-lp-wrap.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation,
        .corner-lp-wrap.fixed .filter-listbar .inner {
          transform: translateY(0px);
        }
      }
    }
  }

  &.specialty-page {
    padding-bottom: ${pagePaddingBottom}px;
    --navi-pin-top: ${fixedTop}px;

    .corner-navi.fixed .event-navigation-type2,
    .bottom-product-wrap .filter-listbar.is-pinned .inner,
    .bottom-product-wrap .lp-filter-bar.is-pinned .pin-area {
      transition: transform 0.3s;
      top: ${fixedTop}px;
    }

    .brand-list-wrap.is-sticky .brand-list {
      transition: transform 0.3s;
    }

    &.is-scrollUp:has(.sub-gnb-list) {
      --navi-pin-top: ${fixedTopWithSubGnb}px;

      .corner-navi.fixed .event-navigation-type2,
      .bottom-product-wrap .filter-listbar.is-pinned .inner,
      .bottom-product-wrap .lp-filter-bar.is-pinned .pin-area {
        top: ${fixedTopWithSubGnb}px;
      }
    }

    &.is-fix-header {
      &.is-scrollUp {
        .corner-navi.fixed .event-navigation-type2,
        .bottom-product-wrap .filter-listbar.is-pinned .inner,
        .bottom-product-wrap .lp-filter-bar.is-pinned .pin-area,
        .brand-list-wrap.is-sticky .brand-list {
          transform: translateY(50px);
        }
      }

      &.is-scrollDown {
        .corner-navi.fixed .event-navigation-type2,
        .bottom-product-wrap .filter-listbar.is-pinned .inner,
        .bottom-product-wrap .lp-filter-bar.is-pinned .pin-area,
        .brand-list-wrap.is-sticky .brand-list {
          transform: translateY(0px);
        }
      }
    }
  }

  &.is-app {
    &.event-mainLayout {
      .corner-navi.fixed .event-navigation,
      .corner-navi2.fixed .event-navigation-type2,
      .corner-lp-wrap.fixed .corner-lp-navi .event-navigation {
        top: -1px;
        transform: translateY(0) !important;
      }

      .Anchor {
        scroll-margin-top: 50px;
      }

      .is-andrd {
        &.view-product-btn {
          bottom: 110px; // 안드로이드앱 헤더 o

          &.is-pinned {
            bottom: 60px; // 안드로이드앱 헤더 x
          }
        }
      }
    }

    &.mega-promotion-page {
      .Anchor {
        scroll-margin-top: 50px;
      }

      .corner-navi.fixed .event-navigation,
      .corner-navi.fixed .event-navigation-type2,
      .corner-collection-section.fixed .category-tab .menubar-swiper,
      .corner-lp-wrap.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation,
      .corner-lp-wrap.fixed .filter-listbar .inner {
        top: -1px;
        transform: translateY(0) !important;
      }
    }

    &.specialty-page {
      --navi-pin-top: 0px;

      .corner-navi.fixed .event-navigation-type2,
      .bottom-product-wrap .filter-listbar.is-pinned .inner,
      .bottom-product-wrap .lp-filter-bar.is-pinned .pin-area {
        top: 0;
        transform: translateY(0) !important;
      }

      .brand-list-wrap.is-sticky .brand-list {
        transform: translateY(0) !important;
      }
    }

    &.sale-page {
      .area-menu.is-pinned .inner-area-menu:not(:has(.lp-filter-bar)),
      .area-menu.is-pinned:has(.lp-filter-bar) .category-menubar {
        top: 0;
        transform: translateY(0) !important;
      }

      .area-menu.is-pinned-filter .lp-filter-bar .pin-area {
        top: ${categoryMenuBarHeight}px;
        transform: translateY(0) !important;
      }

      @media ${({ theme }) => theme.media.smMax} {
        .area-menu.is-pinned-filter .lp-filter-bar .pin-area {
          top: ${mixin.pxToVw('49')};
        }
      }
    }

    /* 웹뷰는 위에서 오르내릴 헤더가 없다. 탭 라벨이 화면 최상단에 붙고
       그 아래 줄(상품 탭은 필터바, 브랜드 탭은 정렬바)은 라벨 높이만큼 내려 붙는다 */
    &.exclusive-page {
      .tabs.is-pinned .tabs-label {
        top: 0;
        transform: translateY(0) !important;
      }

      .tabs.is-pinned .filter-listbar .inner,
      .tabs.is-pinned-filter .lp-filter-bar .pin-area,
      .tabs.is-pinned .sorting-accrdn .inner-sorting {
        top: ${exclusiveTabsLabelHeight}px;
        transform: translateY(0) !important;
      }

      @media ${({ theme }) => theme.media.smMax} {
        .tabs.is-pinned .filter-listbar .inner,
        .tabs.is-pinned-filter .lp-filter-bar .pin-area,
        .tabs.is-pinned .sorting-accrdn .inner-sorting {
          top: ${mixin.pxToVw(String(exclusiveTabsLabelHeight))};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .box-main-header {
      height: calc(50px + ${mixin.pxToVw('43')});

      .inner-box-main-header .sub-gnb-list .swiper {
        padding: ${mixin.pxToVw('8 20 14')};

        .swiper-slide + .swiper-slide {
          margin-left: ${mixin.pxToVw('6')};
        }
      }
    }

    &:not(.is-fix-header) .box-main-header:has(.sub-gnb-list) {
      height: calc(50px + ${mixin.pxToVw('135')});
    }

    &.main-page {
      #container > .content {
        margin-top: calc(-50px + ${mixin.pxToVw('-43')});
      }
    }

    &.best-page {
      padding-bottom: ${mixin.pxToVw(String(pagePaddingBottom))};

      .area-menu {
        height: ${mixin.pxToVw('50')};

        &.is-3deps {
          height: ${mixin.pxToVw('91')};
        }
      }

      &.is-fix-header {
        .inner-area-menu {
          top: ${mixin.pxToVw(String(fixedTop))};
        }
      }
    }

    &.main-category-page {
      padding-bottom: ${mixin.pxToVw(String(pagePaddingBottom))};
    }

    &.for-you-page {
      padding-bottom: ${mixin.pxToVw(String(pagePaddingBottom))};

      .for-you-main-template {
        .area-menu {
          height: ${mixin.pxToVw('53')};

          &.is-pinned .inner-area-menu {
            top: ${mixin.pxToVw(String(fixedTop))};
          }
        }
      }
    }

    &.new-page {
      padding-bottom: ${mixin.pxToVw(String(pagePaddingBottom))};

      .lp-filter-bar.is-pinned .pin-area {
        top: ${mixin.pxToVw(String(fixedTop))};
      }
    }

    &.sale-page {
      padding-bottom: ${mixin.pxToVw(String(pagePaddingBottom))};

      /* 구필터바(.filter-listbar) 구조 전용.
         LP 필터바는 행 수(선택칩 유무)에 따라 높이가 달라져 고정 높이를 쓸 수 없고,
         .inner-area-menu가 fixed가 아니라 relative라 top을 주면 그대로 밀린다 */
      .area-menu:not(:has(.lp-filter-bar)) {
        height: ${mixin.pxToVw('105')};

        &.is-pinned .inner-area-menu {
          top: ${mixin.pxToVw(String(fixedTop))};
        }
      }
    }

    &.exclusive-page {
      padding-bottom: ${mixin.pxToVw(String(pagePaddingBottom))};

      .tabs.is-pinned .tabs-label,
      .tabs.is-pinned .filter-listbar .inner,
      .tabs.is-pinned-filter .lp-filter-bar .pin-area,
      .tabs.is-pinned .sorting-accrdn .inner-sorting {
        top: ${mixin.pxToVw('5')};
      }

      &.is-scrollUp {
        .tabs.is-pinned .tabs-label {
          transform: translateY(calc(50px + ${mixin.pxToVw('36')}));
        }

        .tabs.is-pinned .filter-listbar .inner,
        .tabs.is-pinned-filter .lp-filter-bar .pin-area,
        .tabs.is-pinned .sorting-accrdn .inner-sorting {
          transform: translateY(calc(50px + ${mixin.pxToVw('80')}));
        }
      }

      &.is-scrollDown {
        .tabs.is-pinned .tabs-label {
          transform: translateY(${mixin.pxToVw('38')});
        }

        .tabs.is-pinned .filter-listbar .inner,
        .tabs.is-pinned-filter .lp-filter-bar .pin-area,
        .tabs.is-pinned .sorting-accrdn .inner-sorting {
          transform: translateY(${mixin.pxToVw('82')});
        }
      }
    }

    &.event-mainLayout {
      .corner-navi.fixed .event-navigation,
      .corner-navi2.fixed .event-navigation-type2,
      .corner-lp-wrap.fixed .corner-lp-navi .event-navigation {
        top: ${mixin.pxToVw(String(fixedTop))};
      }

      &.is-app .Anchor {
        scroll-margin-top: ${mixin.pxToVw('50')};
      }

      &.is-fix-header {
        &.is-scrollUp:has(.sub-gnb-list) {
          .corner-navi.fixed .event-navigation,
          .corner-navi2.fixed .event-navigation-type2,
          .corner-lp-wrap.fixed .corner-lp-navi .event-navigation {
            top: ${mixin.pxToVw(String(fixedTopWithSubGnb))};
          }
        }
      }

      .view-product-btn {
        bottom: calc(constant(safe-area-inset-bottom) + ${mixin.pxToVw('60')});
        bottom: calc(env(safe-area-inset-bottom) + ${mixin.pxToVw('60')});
      }
    }

    &.mega-promotion-page {
      padding-bottom: ${mixin.pxToVw(String(pagePaddingBottom))};

      .corner-lp-wrap.fixed .filter-listbar {
        height: ${mixin.pxToVw('64')};
      }

      .corner-lp-wrap.fixed .evt-ctg-navigation-wrap {
        height: ${mixin.pxToVw('56')};
      }

      .corner-navi.fixed .event-navigation,
      .corner-navi.fixed .event-navigation-type2,
      .corner-lp-wrap.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation,
      .corner-lp-wrap.fixed .filter-listbar .inner {
        top: ${mixin.pxToVw(String(fixedTop))};
      }

      &.is-app .Anchor {
        scroll-margin-top: ${mixin.pxToVw('50')};
      }

      &.is-scrollUp:has(.sub-gnb-list) {
        .corner-navi.fixed .event-navigation,
        .corner-navi.fixed .event-navigation-type2,
        .corner-collection-section.fixed .category-tab .menubar-swiper,
        .corner-lp-wrap.fixed .evt-ctg-navigation-wrap .evt-ctg-navigation {
          top: ${mixin.pxToVw(String(fixedTopWithSubGnb))};
        }
      }
    }

    &.specialty-page {
      padding-bottom: ${mixin.pxToVw('145')};
      --navi-pin-top: ${mixin.pxToVw(String(fixedTop))};

      .corner-navi.fixed .event-navigation-type2,
      .bottom-product-wrap .filter-listbar.is-pinned .inner,
      .bottom-product-wrap .lp-filter-bar.is-pinned .pin-area {
        top: ${mixin.pxToVw(String(fixedTop))};
      }

      &.is-scrollUp:has(.sub-gnb-list) {
        --navi-pin-top: ${mixin.pxToVw(String(fixedTopWithSubGnb))};

        .corner-navi.fixed .event-navigation-type2,
        .bottom-product-wrap .filter-listbar.is-pinned .inner,
        .bottom-product-wrap .lp-filter-bar.is-pinned .pin-area {
          top: ${mixin.pxToVw(String(fixedTopWithSubGnb))};
        }
      }
    }
  }
`;
